import { set } from "lodash";
import validate from "validate.js";

export const validateFieldWithKey = (constraintsObj, fieldName, value, section) => {
    const searchIn = section && constraintsObj[section] ? constraintsObj[section] : constraintsObj;
    const fullKey = Object.keys(searchIn).find((key) => key === fieldName || key.endsWith("." + fieldName));
    if (!fullKey) return { fullKey: null, result: null };

    const fieldConstraint = searchIn[fullKey];
    if (!fieldConstraint || Object.keys(fieldConstraint).length === 0) {
        return { fullKey, result: null };
    }
    const data = set({}, fullKey, value);
    const result = validate(data, { [fullKey]: fieldConstraint }, { fullMessages: false });
    return { fullKey, result };
};

export const findAndValidateField = (constraintsObj, fieldName, value, section) => {
    const sectionConstraints = constraintsObj[section];
    const data = {};
    if (!sectionConstraints) {
        const fullKey = Object.keys(constraintsObj).find((key) => key === fieldName || key.endsWith("." + fieldName));
        if (!fullKey) return null;
        const fieldConstraint = constraintsObj[fullKey];
        set(data, fullKey, value);
        return validate(data, { [fullKey]: fieldConstraint }, { fullMessages: false });
    } else {
        const fullKey = Object.keys(sectionConstraints).find(
            (key) => key === fieldName || key.endsWith("." + fieldName)
        );
        if (!fullKey) return null;

        const fieldConstraint = sectionConstraints[fullKey];
        if (!fieldConstraint || Object.keys(fieldConstraint).length === 0) return null;

        set(data, fullKey, value);
        return validate(data, { [fullKey]: fieldConstraint }, { fullMessages: false });
    }
};

// Whether a validation entry's fullKey refers to the field that was just blurred.
// Handles prefix differences across forms (e.g. "listing.askingRentMax", "deal.amount",
// "<splitKey>.netAmount") by matching on exact equality or the trailing field segment.
export const isBlurredFieldEntry = (fullKey, blurredId) => {
    if (!fullKey || !blurredId) return false;
    if (fullKey === blurredId) return true;
    const blurredField = String(blurredId).split(".").pop();
    const entryField = String(fullKey).split(".").pop();
    return entryField === blurredField;
};
